import React from 'react';
import {
  Box,
  Card,
  Typography,
  Drawer,
  IconButton,
  Button,
  Divider
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory';

import Config from './components/ClientConfig';

import OverviewSales from './components/biReports/OverviewSales_';
import ProductChartGroup from './components/biReports/ProductChartGroup';
import OverviewOrders from './components/biReports/OverviewOrders';
import OrderFeedbackView from './components/biReports/sOrderFeedbackView';

import SalesOrderView from './components/biReports/SalesOrderView';
import InventoryUI from './components/biReports/InventoryUi';
import PurchaseOrderUI from './components/biReports/PurchaseOrderUI';
import PurchaseReceiptUI from './components/biReports/PurchaseReceiptUI';
import RawMaterialConsumption from './components/biReports/InventoryRMConsumption';
import SalesCategoryMix from './components/biReports/SalesCategoryMix';
import SalesClassMix from './components/biReports/SalesClassMix';

import Client from './components/Client';
import kalopsia_logo from './images/kalopsia_logo.png';

const drawerWidth = 240;

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      config: {},

      activePage: "overview",
      mobileDrawerOpen: false
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
  }

  getData() {
    let queryLogo = { "key": "LOGO" };
    let dataLogo = this.state.client.getData(Config.API_URL_CONFIG_MOBILEAPP_IMAGE, queryLogo);

    if (dataLogo) {
      this.setState({ config: dataLogo });
    }
  }

  getLogo() {
    let logo = kalopsia_logo;

    if (this.state.config) {
      let config = this.state.config;

      if (config.MobileAppImageConfigs) {
        let filteredConfig = {};

        for (let i = 0; i < config.MobileAppImageConfigs.length; i++) {
          if (config.MobileAppImageConfigs[i].key === 'LOGO') {
            filteredConfig = config.MobileAppImageConfigs[i];
          }
        }

        if (filteredConfig && filteredConfig.image) {
          logo = Config.BASE_URL + filteredConfig.image;
        }
      }
    }

    return logo;
  }

  setActivePage = (page) => {
    this.setState({
      activePage: page,
      mobileDrawerOpen: false
    });
  };

  toggleMobileDrawer = () => {
    this.setState((prev) => ({
      mobileDrawerOpen: !prev.mobileDrawerOpen
    }));
  };

  getPageTitle() {
    switch (this.state.activePage) {
      case "overview":
        return "Overview";

      case "sales-products":
        return "Sales / Products";
      case "sales-categories":
        return "Sales / Categories";
      case "sales-classes":
        return "Sales / Classes";
      case "sales-orders":
        return "Sales / Orders";
      case "sales-view":
        return "Sales / o.view";

      case "inventory-inv":
        return "Inventory / inv.";
      case "inventory-supply":
        return "Inventory / supply";
      case "inventory-nir":
        return "Inventory / nir";
      case "inventory-cons":
        return "Inventory / cons";

      case "control-feedback":
        return "Control / Feedback";

      default:
        return "Overview";
    }
  }

  renderActiveContent() {
    switch (this.state.activePage) {
      case "overview":
        return <OverviewSales />;

      case "sales-products":
        return <ProductChartGroup />;
      case "sales-categories":
        return <SalesCategoryMix />;
      case "sales-classes":
        return <SalesClassMix />;
      case "sales-orders":
        return <OverviewOrders />;
      case "sales-view":
        return <SalesOrderView />;

      case "inventory-inv":
        return <InventoryUI />;
      case "inventory-supply":
        return <PurchaseOrderUI />;
      case "inventory-nir":
        return <PurchaseReceiptUI />;
      case "inventory-cons":
        return <RawMaterialConsumption />;

      case "control-feedback":
        return <OrderFeedbackView />;

      default:
        return <OverviewSales />;
    }
  }

  menuButtonSx(page) {
    const active = this.state.activePage === page;

    return {
      justifyContent: "flex-start",
      textTransform: "none",
      width: "100%",
      minHeight: 38,
      px: 1.25,
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: active ? 800 : 600,
      color: active ? "#FFFFFF" : "rgba(255,255,255,0.76)",
      backgroundColor: active ? "rgba(255,255,255,0.11)" : "transparent",
      "&:hover": {
        backgroundColor: active ? "rgba(255,255,255,0.14)" : "rgba(255,255,255,0.07)"
      }
    };
  }

  sectionTitleSx() {
    return {
      color: "rgba(255,255,255,0.55)",
      fontSize: "11px",
      fontWeight: 800,
      letterSpacing: "0.7px",
      textTransform: "uppercase",
      px: 1.25,
      mt: 1.25,
      mb: 0.5
    };
  }

  renderMenuContent() {
    const logo = this.getLogo();

    return (
      <Box
        sx={{
          height: "100%",
          background: "#202c38",
          color: "#FFFFFF",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Sidebar header */}
        <Box
          sx={{
            px: 2,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.25
          }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "16px",
              background: "rgba(255,255,255,0.09)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flex: "0 0 auto"
            }}
          >
            <img
              src={logo}
              width="46px"
              alt="logo"
              style={{ display: "block" }}
            />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: 1.1,
                fontWeight: 800,
                color: "#FFFFFF"
              }}
            >
              Kalopsia
            </Typography>

            <Typography
              sx={{
                fontSize: "12px",
                color: "rgba(255,255,255,0.62)",
                mt: 0.25,
                whiteSpace: "nowrap"
              }}
            >
              Business overview
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.10)" }} />

        {/* Navigation */}
        <Box
          sx={{
            p: 1,
            overflowY: "auto",
            flex: 1
          }}
        >
          <Button
            startIcon={<DashboardIcon fontSize="small" />}
            onClick={() => this.setActivePage("overview")}
            sx={this.menuButtonSx("overview")}
          >
            Overview
          </Button>

          <Typography sx={this.sectionTitleSx()}>
            Sales
          </Typography>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("sales-products")}
            sx={this.menuButtonSx("sales-products")}
          >
            Products
          </Button>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("sales-categories")}
            sx={this.menuButtonSx("sales-categories")}
          >
            Categories
          </Button>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("sales-classes")}
            sx={this.menuButtonSx("sales-classes")}
          >
            Classes
          </Button>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("sales-orders")}
            sx={this.menuButtonSx("sales-orders")}
          >
            Orders
          </Button>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("sales-view")}
            sx={this.menuButtonSx("sales-view")}
          >
            o.view
          </Button>

          <Typography sx={this.sectionTitleSx()}>
            Inventory
          </Typography>

          <Button
            startIcon={<InventoryIcon fontSize="small" />}
            onClick={() => this.setActivePage("inventory-inv")}
            sx={this.menuButtonSx("inventory-inv")}
          >
            inv.
          </Button>

          <Button
            startIcon={<InventoryIcon fontSize="small" />}
            onClick={() => this.setActivePage("inventory-supply")}
            sx={this.menuButtonSx("inventory-supply")}
          >
            supply
          </Button>

          <Button
            startIcon={<InventoryIcon fontSize="small" />}
            onClick={() => this.setActivePage("inventory-nir")}
            sx={this.menuButtonSx("inventory-nir")}
          >
            nir
          </Button>

          <Button
            startIcon={<InventoryIcon fontSize="small" />}
            onClick={() => this.setActivePage("inventory-cons")}
            sx={this.menuButtonSx("inventory-cons")}
          >
            cons
          </Button>

          <Typography sx={this.sectionTitleSx()}>
            Control
          </Typography>

          <Button
            startIcon={<AssessmentIcon fontSize="small" />}
            onClick={() => this.setActivePage("control-feedback")}
            sx={this.menuButtonSx("control-feedback")}
          >
            Feedback
          </Button>
        </Box>
      </Box>
    );
  }

  render() {
    const logo = this.getLogo();

    return (
      <Box
        component="main"
        sx={{
          background: "#1e2833",
          minHeight: "100vh",
          display: "flex"
        }}
      >
        {/* Desktop sidebar */}
        <Box
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            display: {
              xs: "none",
              md: "block"
            }
          }}
        >
          <Box
            sx={{
              width: drawerWidth,
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              boxShadow: "4px 0 18px rgba(0,0,0,0.22)"
            }}
          >
            {this.renderMenuContent()}
          </Box>
        </Box>

        {/* Mobile drawer */}
        <Drawer
          open={this.state.mobileDrawerOpen}
          onClose={this.toggleMobileDrawer}
          variant="temporary"
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: {
              xs: "block",
              md: "none"
            },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              border: "none"
            }
          }}
        >
          {this.renderMenuContent()}
        </Drawer>

        {/* Content */}
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            px: {
              xs: 1,
              sm: 2
            },
            py: {
              xs: 1,
              sm: 1.5
            }
          }}
        >
          {/* Mobile top bar */}
          <Box
            sx={{
              display: {
                xs: "flex",
                md: "none"
              },
              alignItems: "center",
              mb: 1,
              gap: 1
            }}
          >
            <IconButton
              onClick={this.toggleMobileDrawer}
              sx={{
                color: "#FFFFFF",
                background: "rgba(255,255,255,0.08)",
                width: 40,
                height: 40,
                borderRadius: "12px",
                "&:hover": {
                  background: "rgba(255,255,255,0.12)"
                }
              }}
            >
              <MenuIcon />
            </IconButton>

            <Box
              onClick={() => this.setActivePage("overview")}
              sx={{
                width: 42,
                height: 42,
                borderRadius: "12px",
                background: "rgba(255,255,255,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                cursor: "pointer",
                "&:hover": {
                  background: "rgba(255,255,255,0.12)"
                }
              }}
            >
              <img
                src={logo}
                width="35px"
                alt="logo"
                style={{ display: "block" }}
              />
            </Box>

            <Box
              sx={{
                minWidth: 0,
                cursor: "pointer"
              }}
              onClick={() => this.setActivePage("overview")}
            >
              <Typography
                color="#FFFFFF"
                sx={{
                  lineHeight: 1,
                  fontWeight: 800,
                  letterSpacing: "0.2px",
                  fontSize: "19px"
                }}
              >
                Kalopsia
              </Typography>

              <Typography
                sx={{
                  color: "rgba(255,255,255,0.62)",
                  fontSize: "12px",
                  mt: 0.3,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {this.getPageTitle()}
              </Typography>
            </Box>
          </Box>

          {/* Desktop page title */}
          <Box
            sx={{
              display: {
                xs: "none",
                md: "flex"
              },
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: {
                    md: "24px",
                    lg: "26px"
                  },
                  lineHeight: 1.1,
                  fontWeight: 800
                }}
              >
                {this.getPageTitle()}
              </Typography>

              <Typography
                sx={{
                  color: "rgba(255,255,255,0.62)",
                  fontSize: "13px",
                  mt: 0.35
                }}
              >
                Kalopsia reporting dashboard
              </Typography>
            </Box>
          </Box>

          {/* Report content */}
          <Card
            sx={{
              background: "#263544",
              borderRadius: {
                xs: "14px",
                sm: "16px"
              },
              overflow: "hidden",
              boxShadow: "0 6px 18px rgba(0,0,0,0.28)"
            }}
          >
            <Box sx={this.contentBoxSx()}>
              {this.renderActiveContent()}
            </Box>
          </Card>
        </Box>
      </Box>
    );
  }

  contentBoxSx() {
    return {
      p: {
        xs: 0.75,
        sm: 1.25
      }
    };
  }
}

export default Main;